module.exports = __webpack_public_path__ + "static/media/bpg_mrgvlovani_caps_2010.e9600dda.ttf";